export default class ImageGalleryService {
  static Viewer = null

  async fetchViewer() {
    if (!ImageGalleryService.Viewer) {
      ImageGalleryService.Viewer = (await import(/* webpackChunkName: "img-gallery" */ 'viewerjs')).default
      import(/* webpackChunkName: "img-gallery-style" */ 'viewerjs/dist/viewer.css')
    }
  }

  async create(container, options = {}) {
    this.destroy()
    await this.fetchViewer()
    this.gallery = new ImageGalleryService.Viewer(container, {
      filter(element) {
        return !element.classList.contains('user-photo')
      },
      inheritedAttributes: [],
      toolbar: {
        zoomIn: 0,
        zoomOut: 0,
        oneToOne: 4,
        reset: 0,
        prev: 1,
        play: 0,
        next: 1,
        rotateLeft: 0,
        rotateRight: 0,
        flipHorizontal: 0,
        flipVertical: 0
      },
      ...options
    })
  }

  destroy() {
    this.gallery?.destroy()
  }
}
